import React from 'react';
import blockStyles from '@baseStyles/block.scss';
import styles from './ContentD1.scss';
import ContentB1 from "@components/blocks/ContentB1/ContentB1";
import ContentD1StructuredData from "@components/widgets/StructuredData/ContentD1StructuredData";
import Button from "@components/base/Button/Button";
import language from "@lang/language";
import useDataFileAction from "@hooks/useDataFileAction";

const ContentD1 = ({data, blockSize, videoSize, color = '',}) => {

	if (!data || !data.blockContent.img || !data.blockContent.videoId) {
		return null;
	}

	const {executeAction, ModalPortal} = useDataFileAction();

	let sizeClassMap = {
		'XS': {
			size: blockStyles.sizeXS,
			seo: {}
		},
		'S': {
			size: blockStyles.sizeS,
			seo: {}
		},
		'M': {
			size: blockStyles.sizeM,
			seo: {}
		},
		'L': {
			size: blockStyles.sizeL,
			seo: {}
		},
		'XL': {
			size: blockStyles.sizeXL,
			seo: {}
		},
		'800': {
			size: blockStyles.w800,
			seo: {}
		},
		'640': {
			size: blockStyles.w640,
			seo: {}
		},
		'360': {
			size: blockStyles.w360,
			seo: {
				imgTag: {
					width: 360,
					height: 640
				}
			}
		}
	}

	return (
	  <div className={blockStyles.baseContainerHolder}>
		  <div
			className={`${styles.container} ${color ? blockStyles[color] : ''} ${sizeClassMap[blockSize]?.size ? sizeClassMap[blockSize]?.size : ''}`}>
			  {/* INTRO CONTAINER TOP */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  {(data.blockIntro?.top?.blockTitle || data.blockIntro?.top?.blockDesc) &&
				<div className={'baseMarginBottom'}>
					<ContentB1
					  title={data.blockIntro.top.blockTitle}
					  desc={data.blockIntro.top.blockDesc}
					  titleSize={blockStyles[data.blockIntro.top.titleSize]}
					/>
				</div>
			  }

			  {/* Button */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  {data.blockIntro?.top?.buttonText &&
				<div className={'baseMarginTop tcenter'}>
					<Button
					  value={data.blockIntro.top.buttonText}
					  onClick={() => executeAction(data.blockIntro.top)}
					/>
				</div>
			  }

			  {/* VIDEO */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  <div
				tabIndex="0"
				className={`${blockStyles.videoThumb} ${sizeClassMap[videoSize]?.size ? sizeClassMap[videoSize]?.size : ''}`}
				onClick={() => {
					if (data.blockContent.videoId && data.blockContent.VideoModal) {
						executeAction(data.blockContent, {
							data: data.blockContent,
							color: color,
							platform: data.blockContent.platform,
							key: Date.now()
						});
					}
				}}>
				  <img
					src={data.blockContent.img}
					alt={data.blockContent.title ?? 'video image'}
					title={data.blockContent.title + language.shBGTitle ?? 'video image' + language.shBGTitle}
					width={sizeClassMap[videoSize]?.seo.imgTag?.width ?? null}
					height={sizeClassMap[videoSize]?.seo.imgTag?.height ?? null}
				  />
			  </div>

			  {/* INTRO CONTAINER BOTTOM */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  {(data.blockIntro?.bottom?.blockTitle || data.blockIntro?.bottom?.blockDesc) &&
				<div className={'baseMarginTop'}>
					<ContentB1
					  title={data.blockIntro.bottom.blockTitle}
					  desc={data.blockIntro.bottom.blockDesc}
					  titleSize={blockStyles[data.blockIntro.bottom.titleSize]}
					/>
				</div>
			  }

			  {/* Button */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  {data.blockIntro?.bottom?.buttonText &&
				<div className={'baseMarginTop tcenter'}>
					<Button
					  value={data.blockIntro.bottom.buttonText}
					  onClick={() => executeAction(data.blockIntro.bottom)}
					/>
				</div>
			  }

			  {/* Render modal with portal (in html.php container - <div id="modalContainer"></div>) */}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
			  {ModalPortal}
			  {/*///////////////////////////////////////////////////////////////////////////////*/}
		  </div>

		  <ContentD1StructuredData data={data}></ContentD1StructuredData>
	  </div>
	)
}

export default ContentD1;
